var exports = {
  "k": "xe564cbfb--f6a3b1--container",
};

module.exports = exports;
